import { useLocale } from 'next-intl';
import { Link } from '@/i18n/routing';

export type BreadcrumbItemType = {
  label: string;
  url?: string;
  current?: boolean;
  icon?: any;
};

export const Breadcrumbs = ({ linksData }: { linksData: BreadcrumbItemType[] }) => {
  const currentLang = useLocale() as 'ar' | 'en';

  const breadcrumbsDataBasedOnLang = currentLang === 'en' ? linksData : linksData.reverse();

  return (
    <div className="flex rounded-lg pt-3 text-gray-700" aria-label="Breadcrumb">
      <ol className="inline-flex items-center space-x-1">
        {breadcrumbsDataBasedOnLang.map((item: BreadcrumbItemType, index: number) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="3"
                stroke="currentColor"
                className={`mx-1 mb-[4px] h-3 w-3 font-bold ${currentLang === 'ar' && 'rotate-180'}`}
              >
                <path strokeLinecap="round" strokeLinejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5" />
              </svg>
            )}
            {item.url ? (
              <Link
                href={item.url}
                className="hover:text-primary-600 inline-flex items-center text-xs font-medium text-gray-700"
              >
                {item.icon && item.icon}
                <span className="text-lg font-bold">{item.label}</span>
              </Link>
            ) : (
              <span
                className={`text-lg ${
                  item.current ? 'font-bold text-gray-200' : 'text-gray-500'
                } dark:text-gray-400`}
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  );
};
